// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signature .thumbnail {
  aspect-ratio: initial;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Forms/Signature/Signature.scss"],"names":[],"mappings":"AACI;EACI,qBAAA;EACA,eAAA;AAAR","sourcesContent":[".signature {\r\n    .thumbnail {\r\n        aspect-ratio: initial;\r\n        max-width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
